import React from 'react';
import IconButton from '@mui/material/IconButton';
import { BUDGET_SOURCE, StructureItem, useProjectDataContext } from 'domain/shared/newProject';
import { Tooltip } from 'framework/ui/mui-builder';
import { useFieldHelper, FieldProps, LinkField } from 'framework/ui/field';
import ContentPaste from '@mui/icons-material/ContentPaste';
import { SearchResultAttachmentsListField } from 'domain/shared/artifact/field';

interface BudgetSourceFieldProps extends FieldProps {
  financeBudgetSource: string;
}

const BudgetSourceField = ({ source, financeBudgetSource }: BudgetSourceFieldProps) => {
  const { getValue: getBudget } = useFieldHelper<StructureItem>({ source });
  const { getValue: getFinance } = useFieldHelper<StructureItem>({ source: financeBudgetSource });
  const { data: project } = useProjectDataContext();
  const budget = getBudget();
  const finance = getFinance();

  let dataSource = budget?.source;
  let data = budget;
  if (!dataSource) {
    dataSource = finance?.source;
    data = finance;
  }

  return (
    <>
      {dataSource === BUDGET_SOURCE.SOW && (
        <SearchResultAttachmentsListField
          source=""
          value={data?.relatedDocuments || []}
          budgetId={project?.budgetData?.defaultBudgetId}
        />
      )}
      {(dataSource === BUDGET_SOURCE.WASTE_REPORT || dataSource === BUDGET_SOURCE.CHANGE_REQUEST) &&
        data.sourceAlias && (
          <LinkField isInternal linkText={data.sourceAlias} value={`#${data.sourceAlias.toLowerCase()}`} />
        )}
      {dataSource === BUDGET_SOURCE.MANUAL_EDIT &&
        (data.comment ? (
          <Tooltip title={data?.comment}>
            <IconButton size="small" sx={{ color: 'text.secondary', p: 0 }}>
              <ContentPaste sx={{ fontSize: '18px' }} />
            </IconButton>
          </Tooltip>
        ) : (
          <></>
        ))}
    </>
  );
};
export default BudgetSourceField;
